import React from "react"
import BmiNewsletterStyle from "../../bmiCalculator/components/shared/bmiNewsletter/BmiNewsletterStyle.module.styl"
import BmiNewsletterImage from "../../../assets/images/bmi-newsletter.png"
import translate from "../../../translation/translator"
import keys from "../../../translation/keys"

const CalorieCalculatorNewsletter = ({
  email,
  handleChangeEmail,
  error,
  handleSubmit,
  locale,
}) => {
  return (
    <div className={BmiNewsletterStyle.wrapper}>
      <div className={BmiNewsletterStyle.image_holder}>
        <img src={BmiNewsletterImage} alt="newsletter" />
      </div>
      <div className={BmiNewsletterStyle.description}>
        <h3 className={BmiNewsletterStyle.title}>Безплатни съвети</h3>
        <p>
          {translate(keys.DIABETICS_NEWSLTTR_FREE_TIPS, locale)}{" "}
          <span>{translate(keys.DIABETICS_NEWSLTTR_HOW_TO_PICK, locale)}</span>{" "}
          {translate(keys.DIABETICS_NEWSLTTR_FREE, locale)}{" "}
        </p>
        <form
          name="free-advice-form"
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <input type="hidden" name="form-name" value="free-advice-form" />
          <div className={BmiNewsletterStyle.input_holder}>
            <input
              name="email"
              required
              type="text"
              value={email}
              onChange={handleChangeEmail}
              placeholder="yourname@mail.com"
            />
            {error && <span className="contact-error">{error}</span>}
            <button type="submit" onClick={handleSubmit}>
              {translate(keys.DIABETICS_NEWSLTTR_SUBSCRIBE, locale)}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CalorieCalculatorNewsletter
